export const ORGANIZATION_SELECTION_PATH = "/select-tenant"

/** Only dashboard destinations are accepted; never navigate to an external origin. */
export function organizationReturnTo(value: string | null): string {
  if (!value || /[\u0000-\u001f\u007f]/.test(value) || !/^\/(?:[?#]|$)/.test(value)) return "/"
  const url = new URL(value, "https://versafy.invalid")
  if (url.origin !== "https://versafy.invalid" || url.pathname !== "/") return "/"
  return `${url.pathname}${url.search}${url.hash}`
}
